// extracted by mini-css-extract-plugin
export default {"chat_box_wrapper":"TemplateAIInput_chat_box_wrapper__sjE6z"};